import { MEDIA, FOUNDER } from "@/data/content";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16"
    >
      <div className="mx-auto max-w-7xl grid lg:grid-cols-12 gap-14 items-center">
        {/* Image side */}
        <div className="lg:col-span-5 relative">
          <div className="relative">
            <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-brand-amber/30 via-brand-violet/20 to-transparent blur-2xl opacity-60" />
            <div className="relative overflow-hidden rounded-[1.75rem] border border-white/10">
              <img
                src={MEDIA.coach}
                alt={`${FOUNDER.name} — Founder of Tapping Into Life LLC`}
                className="w-full h-[560px] object-cover object-top"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="font-accent text-2xl text-brand-gold">— {FOUNDER.name}</p>
                <p className="text-xs uppercase tracking-[0.22em] text-zinc-300 mt-1">
                  Founder · Spiritual Life Coach
                </p>
              </div>
            </div>
          </div>

          {/* Floating quote card */}
          <div className="hidden md:block absolute -right-8 bottom-10 bg-brand-surface border border-brand-border p-6 max-w-xs rounded-2xl shadow-2xl">
            <div className="text-brand-gold font-serif text-3xl leading-none">"</div>
            <p className="mt-2 text-sm text-zinc-300 leading-relaxed">
              Your greatness starts with knowing who you are as a creation of God.
            </p>
          </div>
        </div>

        {/* Copy side */}
        <div className="lg:col-span-7 lg:pl-8">
          <div className="text-xs font-sans tracking-[0.22em] uppercase text-zinc-500 overline-line">
            About the Founder
          </div>

          <h2 className="mt-6 font-serif text-4xl sm:text-5xl md:text-6xl font-light leading-[1.05] text-white">
            Meet <span className="italic text-rainbow not-italic font-medium">{FOUNDER.name}</span>.
          </h2>

          <div className="mt-8 space-y-5 text-zinc-400 text-lg leading-relaxed max-w-2xl">
            {FOUNDER.bio.map((p, i) => (
              <p key={i} data-testid={`about-bio-${i}`}>
                {p}
              </p>
            ))}
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-6 max-w-2xl">
            {FOUNDER.credentials.map((b) => (
              <div
                key={b.value}
                className="border-l border-brand-border pl-4"
                data-testid={`about-badge-${b.value.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="text-xs uppercase tracking-widest text-zinc-500">{b.label}</div>
                <div className="font-serif text-xl text-white mt-1">{b.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
